export const voyagerEmailAddress = { name: 'Voyager', address: 'voyager@getrocket.com' };
export const clientCommsEmailAddress = { name: 'Client Comms', address: 'clientcomms@getrocket.com' };
export const candidateCommsEmailAddress = { name: 'Candidate Comms', address: 'candidatecomms@getrocket.com' };
